import { useLocation } from 'react-router';

import useAppNavigate from './useAppNavigation';

/**
 * «Назад» с экрана записи. Пришли внутри кабинета — шаг назад по истории: список
 * откроется с теми же поиском, фильтрами и страницей. Открыли ссылку напрямую
 * (истории кабинета нет) — переход на `fallback`, обычно родительский раздел.
 */
const useGoBack = (): ((fallback: string) => void) => {
  const location = useLocation();
  const { navigate } = useAppNavigate();

  return (fallback: string) => {
    if (location.key === 'default') {
      navigate(fallback);
      return;
    }
    navigate(-1);
  };
};

export default useGoBack;
